<template>
  <BreadCrumb :PageTitle="t('breadCrumb.providerBalances')" />
  <BalanceContent />
</template>

<script lang="ts">
import { defineComponent,onMounted } from "vue";
import stateStore from "../../utils/store";
import { useI18n } from "vue-i18n";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import BalanceContent from "../../components/Financial/BalanceContent.vue";


export default defineComponent({
  name: "BalancePage",
  components: {
    BreadCrumb,
    BalanceContent,
  },
  setup(){
    const { t } = useI18n();
    const stateStoreInstance = stateStore;
    document.body.classList.remove("sidebar-hide");
    document.body.classList.add("sidebar-show");
    onMounted(() => {
          stateStoreInstance.show = true;
        });
       return {stateStoreInstance, t};
  }
});
</script>